import {
    SET_HIGHLIGHTED_POI_IMAGE,
    SET_HIGHLIGHTED_POI_IMAGE_FAILURE,
    SET_HIGHLIGHTED_POI_IMAGE_SUCCESS,
} from 'store/actions/types';

export const setHighlightedPointsOfInterestImage = (payload) => {
    return {
        type: SET_HIGHLIGHTED_POI_IMAGE,
        payload: payload,
    };
};

export const setHighlightedPointsOfInterestImageFailure = (error) => {
    return {
        type: SET_HIGHLIGHTED_POI_IMAGE_FAILURE,
        error: error,
    };
};

export const setHighlightedPointsOfInterestImageSuccess = (pointOfInterestId, response) => {
    return {
        type: SET_HIGHLIGHTED_POI_IMAGE_SUCCESS,
        pointOfInterestId,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/images/setHighlightedPointsOfInterestImage.js